module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-store"
  }, [_c('content-item', {
    attrs: {
      "noPadding": true
    }
  }, [_c('div', {
    staticClass: "store-main"
  }, [_c('div', {
    staticClass: "left-nav",
    attrs: {
      "id": "left"
    }
  }, [_c('div', {
    staticClass: "user-info"
  }, [(_vm.user.accessToken) ? [_c('h4', [_vm._v(_vm._s(_vm.user.username)), _c('span', {
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("[" + _vm._s(_vm.$t('logout')) + "]")])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('egPoint')) + " "), _c('span', [_vm._v(_vm._s(_vm.totalEg))])])] : [_c('h4', {
    staticClass: "login"
  }, [_c('em', {
    on: {
      "click": _vm.login
    }
  }, [_vm._v(_vm._s(_vm.$t('login')))]), _vm._v("/"), _c('em', {
    on: {
      "click": _vm.register
    }
  }, [_vm._v(_vm._s(_vm.$t('userRegister')))])])]], 2), _vm._v(" "), _c('div', {
    staticClass: "nav-list"
  }, [_c('router-link', {
    attrs: {
      "to": "/store/recharge",
      "active-class": "nav-active"
    }
  }, [_vm._v(_vm._s(_vm.$t('egRecharge')))]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/store/consume",
      "active-class": "nav-active"
    }
  }, [_vm._v(_vm._s(_vm.$t('buyGoods')))]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/store/records/consume",
      "active-class": "nav-active"
    }
  }, [_vm._v(_vm._s(_vm.$t('consumeRecords')) + "\n                    ")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/store/records/recharge",
      "active-class": "nav-active"
    }
  }, [_vm._v(_vm._s(_vm.$t('rechargeRecords')) + "\n                    ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "right-content",
    attrs: {
      "id": "right"
    }
  }, [_c('router-view')], 1)])]), _vm._v(" "), (_vm.showLoginPopup) ? _c('login') : _vm._e(), _vm._v(" "), (_vm.showRegisterPopup) ? _c('register') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-60f44568!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Store.vue
// module id = 382
// module chunks = 3